import { StateCreator } from 'zustand';
import { UserSettings, defaultUserSettings } from '../../types/settings';

export interface SettingsSlice {
  userSettings: UserSettings;
  updateUserSettings: (settings: Partial<UserSettings>) => void;
}

export const createSettingsSlice: StateCreator<SettingsSlice> = (set) => ({
  userSettings: defaultUserSettings,
  
  updateUserSettings: (newSettings) => {
    set((state) => ({
      userSettings: {
        ...state.userSettings,
        ...newSettings
      }
    }));
  }
});